export const EVENT_BEFORE_DESTROY = 'hook:beforeDestroy';
